<template>
  <div class="message-board">
    <form v-if="!submitted" @submit.prevent="submitForm" novalidate>
      <div class="form-row">
        <input type="text" v-model.trim="name" placeholder="姓名 *" required/>
        <input type="tel" v-model.trim="phone" placeholder="手机号码 *" required/>
      </div>
      <div class="form-row">
        <input type="text" v-model.trim="corporate" placeholder="公司名称 *" required/>
        <input type="text" v-model.trim="address" placeholder="地址"/>
      </div>
      <textarea v-model.trim="content" placeholder="请输入您的留言内容或合作意向 *" required></textarea>
      <p class="err-tip" v-if="errTip">{{ errTip }}</p>
      <button type="submit" class="submit-btn" :disabled="submitting">
        {{ submitting ? '提交中…' : '提交留言' }}
      </button>
    </form>
    <div class="success" v-else>
      <div class="success-ico">✓</div>
      <b>留言提交成功</b>
      <p>感谢您的关注，协会秘书处会尽快与您联系。</p>
      <button class="again-btn" @click="resetForm">再写一条</button>
    </div>
  </div>
</template>

<script setup>
import {ref} from 'vue';
import {noPermissionAdd} from "@/api/proposal";

const name = ref('');
const phone = ref('');
const corporate = ref('');
const address = ref('');
const content = ref('');
const submitting = ref(false);
const submitted = ref(false);
const errTip = ref('');

function validate() {
  if (!name.value || !phone.value || !corporate.value || !content.value) {
    return '请填写带 * 的必填项';
  }
  if (!/^1[3-9]\d{9}$/.test(phone.value)) {
    return '请输入正确的手机号码';
  }
  return '';
}

const submitForm = () => {
  const tip = validate();
  if (tip) {
    errTip.value = tip;
    return;
  }
  errTip.value = '';
  submitting.value = true;
  const form = {
    name: name.value,
    phone: phone.value,
    corporate: corporate.value,
    address: address.value,
    content: content.value
  };
  noPermissionAdd(form).then((res) => {
    if (res && (res.code === 200 || res.code === undefined)) {
      submitted.value = true;
    } else {
      errTip.value = (res && res.msg) || '提交失败，请稍后重试';
    }
  }).catch(() => {
    errTip.value = '网络异常，请稍后重试';
  }).finally(() => {
    submitting.value = false;
  });
};

function resetForm() {
  name.value = '';
  phone.value = '';
  corporate.value = '';
  address.value = '';
  content.value = '';
  submitted.value = false;
  errTip.value = '';
}
</script>

<style scoped>
.message-board {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-md);
  padding: 28px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

input,
textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--line);
  border-radius: var(--r-sm);
  padding: 12px 14px;
  font-size: 14px;
  color: var(--text-1);
  background: #fafbfe;
  outline: none;
  transition: border-color var(--fast), background var(--fast);
  font-family: inherit;
  margin-bottom: 14px;
}

input:focus,
textarea:focus {
  border-color: var(--color-primary-500);
  background: #fff;
}

input::placeholder,
textarea::placeholder {
  color: #a8b3c7;
}

textarea {
  min-height: 110px;
  resize: vertical;
  line-height: 1.7;
}

.err-tip {
  color: #d03050;
  font-size: 13px;
  margin: -6px 0 10px;
}

.submit-btn {
  width: 100%;
  border: none;
  border-radius: 999px;
  background: var(--color-primary-500);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  padding: 13px 0;
  cursor: pointer;
  letter-spacing: 4px;
  transition: background var(--fast), transform var(--fast), box-shadow var(--fast);
}

.submit-btn:hover:not(:disabled) {
  background: var(--color-primary-600);
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(29, 91, 214, .3);
}

.submit-btn:disabled {
  opacity: .6;
  cursor: not-allowed;
}

.success {
  text-align: center;
  padding: 30px 0;
}

.success-ico {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 50%;
  background: #e3f7ed;
  color: #149a5b;
  font-size: 28px;
  font-weight: 700;
  display: grid;
  place-items: center;
}

.success b {
  font-size: 18px;
  color: var(--text-1);
}

.success p {
  margin: 8px 0 18px;
  font-size: 13.5px;
  color: var(--text-3);
}

.again-btn {
  border: 1px solid var(--color-primary-500);
  background: transparent;
  color: var(--color-primary-500);
  border-radius: 999px;
  padding: 9px 28px;
  font-size: 14px;
  cursor: pointer;
  transition: background var(--fast);
}

.again-btn:hover {
  background: var(--color-primary-50);
}

@media (max-width: 560px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
}
</style>
